import { render, staticRenderFns } from "./SsalesoderViewcon.vue?vue&type=template&id=705ab216&scoped=true"
import script from "./SsalesoderViewcon.vue?vue&type=script&lang=js"
export * from "./SsalesoderViewcon.vue?vue&type=script&lang=js"
import style0 from "./SsalesoderViewcon.vue?vue&type=style&index=0&id=705ab216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ab216",
  null
  
)

export default component.exports